import { inject, Injectable } from '@angular/core';
import { SessionApiProvider } from '@app/core/session/session-api-provider';
import { Observable } from 'rxjs';
import { SettingsService } from '@app/core/settings/settings.service';
import { SessionOidcApiService } from '@app/core/session/session-oidc-api.service';
import { SessionApiService } from './session-api.service';

@Injectable()
export class SessionApiMigrationProviderService implements SessionApiProvider {

  private readonly settingsService = inject(SettingsService);
  private readonly oidcProvider = inject(SessionOidcApiService);
  private readonly oldProvider = inject(SessionApiService);

  public signOut(): Observable<unknown> {
    return this.getProvider().signOut();
  }

  public authenticateBasically(): Observable<boolean> {
    return this.getProvider().authenticateBasically();
  }

  public getGamesEmbedToken(): Observable<string> {
    return this.getProvider().getGamesEmbedToken();
  }

  private getProvider(): SessionApiProvider {
    return this.settingsService.settings.isHybridLoginFlow() ? this.oidcProvider : this.oldProvider;
  }
}
